import React, { useMemo } from 'react';
import { PredictionHeaderBar } from '../../../components/prediction-header-bar/prediction-header-bar';
import { useConsolidatedOrganisationPredictionBuilderContext } from '../../../context/consolidated-organisation-prediction-builder-context';
import { PredictionHeaderProps, PredictionType } from '../../../types';

export const PredictionHeader = ({ children, ...props }: PredictionHeaderProps) => {
  const {
    handlePredictionTypeChange,
    isEditing,
    predictionType
  } = useConsolidatedOrganisationPredictionBuilderContext();

  const options = useMemo(
    () => [PredictionType.FORMULA, PredictionType.FREESTYLE, PredictionType.REPEATING, PredictionType.UNIT],
    []
  );

  return (
    <PredictionHeaderBar
      isEditing={isEditing}
      onChangePredictionType={handlePredictionTypeChange}
      options={options}
      predictionType={predictionType}
      {...props}
    >
      {children}
    </PredictionHeaderBar>
  );
};
